// extracted by css-extract-rspack-plugin
export default {"root":"root-ngQEVl","title":"title-pjhxXG","description":"description-HD58OJ","img":"img-ruYRqN","action":"action-hDqw_x"};